import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, TransitionGroup as _TransitionGroup, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = {
  key: 0,
  class: "text-left"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", {
  class: "input__field--error_message input__field--error_message--selects",
  textContent: 'Vælg ja eller nej'
}, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = {
  key: "existInsuranceLabel",
  class: "pb-3 text-left",
  textContent: 'Hvilket forsikringsselskab var du senest hos?'
}
const _hoisted_7 = { key: 1 }
const _hoisted_8 = ["textContent"]
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = {
  key: 0,
  class: "text-left"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", {
  class: "input__field--error_message input__field--error_message--selects",
  textContent: 'Vælg ja eller nej'
}, null, -1)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = ["textContent"]
const _hoisted_14 = { key: "validNow" }
const _hoisted_15 = {
  class: "text-left",
  key: "validNowErr"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", {
  class: "input__field--error_message input__field--error_message--selects",
  textContent: 'Vælg ja eller nej'
}, null, -1)
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", {
  class: "pb-3 pt-3 text-left",
  textContent: 'Hvor mange forsikringsskader har du haft de seneste 2 år?'
}, null, -1)
const _hoisted_19 = {
  class: "text-left mt-n3",
  key: "skaderErr"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", {
  class: "input__field--error_message input__field--error_message--selects",
  textContent: 'Vælg antal skader'
}, null, -1)
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = {
  key: "RkiLabel",
  class: "pb-3 text-left"
}
const _hoisted_23 = {
  class: "text-left",
  key: "rkiErr"
}
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", {
  class: "input__field--error_message input__field--error_message--selects",
  textContent: 'Vælg ja eller nej'
}, null, -1)
const _hoisted_25 = [
  _hoisted_24
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RadioComponent = _resolveComponent("RadioComponent")!
  const _component_SelectModalComponent = _resolveComponent("SelectModalComponent")!
  const _component_DatePickerComponent = _resolveComponent("DatePickerComponent")!
  const _component_SegmentedControlComponent = _resolveComponent("SegmentedControlComponent")!
  const _component_PopoverComponent = _resolveComponent("PopoverComponent")!
  const _component_ButtonTapComponent = _resolveComponent("ButtonTapComponent")!

  return (_openBlock(), _createElementBlock("div", null, [
    (!_ctx.isChildAccident)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", {
            class: "pb-3 text-left",
            innerHTML: _ctx.existingInsuranceLabel
          }, null, 8, _hoisted_2),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.jaNejArray, (item, inx) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass([inx + 1 === _ctx.jaNejArray.length ? 'pb-3' : 'pb-2']),
              key: 'existInsurance_' + inx
            }, [
              _createVNode(_component_RadioComponent, {
                name: 'existInsurance',
                id: 'existInsurance' + item.value,
                inputValue: item.value + '',
                preSelect: _ctx.model.additionalInfo.existInsurance,
                trackingLabel: _ctx.existingInsuranceLabel,
                onRadioComponent: _ctx.handleRadioClick
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item.displayValue), 1)
                ]),
                _: 2
              }, 1032, ["id", "inputValue", "preSelect", "trackingLabel", "onRadioComponent"])
            ], 2))
          }), 128)),
          (!_ctx.model.pristineStep.get(_ctx.card.name) && !_ctx.model.additionalInfo.existInsurance)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_TransitionGroup, { name: "slide-simple" }, {
      default: _withCtx(() => [
        (!_ctx.isChildAccident && _ctx.model.additionalInfo.existInsurance === 'ja')
          ? (_openBlock(), _createElementBlock("div", _hoisted_6))
          : _createCommentVNode("", true),
        _withDirectives(_createVNode(_component_SelectModalComponent, {
          key: "existingInsurance",
          id: "existingInsurance",
          name: "existingInsurance",
          preSelect: _ctx.model.additionalInfo.existingInsurance,
          innerData: _ctx.cms.insuranceCompanies,
          selected: _ctx.model.additionalInfo.existingInsurance !== undefined,
          placeholder: "Vælg forsikringsselskab",
          visibleError: !_ctx.model.pristineStep.get(_ctx.card.name),
          errorMsgOverride: "Du skal vælge et forsikringsselskab",
          "onSelectModalComponent:selected": _ctx.selectExistingInsuranceFamily
        }, null, 8, ["preSelect", "innerData", "selected", "visibleError", "onSelectModalComponent:selected"]), [
          [_vShow, !_ctx.isChildAccident && _ctx.model.additionalInfo.existInsurance === 'ja']
        ])
      ]),
      _: 1
    }),
    (_ctx.showPersonsBlock)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.model.familyInfo.personCountId + 1, (inx) => {
            return (_openBlock(), _createElementBlock("div", {
              key: 'ch' + inx
            }, [
              (_openBlock(), _createBlock(_TransitionGroup, {
                name: "slide-simple",
                key: 'cc' + (inx - 1)
              }, {
                default: _withCtx(() => [
                  (_ctx.showPerson(inx - 1))
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 'name' + (inx - 1),
                        class: "h2 text-left pt-3",
                        textContent: _toDisplayString(_ctx.getName(inx - 1))
                      }, null, 8, _hoisted_8))
                    : _createCommentVNode("", true),
                  (_ctx.showPerson(inx - 1))
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 'existInsurance' + (inx - 1)
                      }, [
                        _createElementVNode("div", {
                          class: "pb-3 text-left",
                          innerHTML: _ctx.getExistingInsuranceLabel(inx - 1)
                        }, null, 8, _hoisted_9),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.jaNejArray, (item, inxJaNej) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: _normalizeClass([inxJaNej + 1 === _ctx.jaNejArray.length ? 'pb-3' : 'pb-2']),
                            key: 'existInsurance' + inxJaNej
                          }, [
                            _createVNode(_component_RadioComponent, {
                              name: 'existInsurance' + (inx - 1),
                              id: 'existInsurance' + (inx - 1) + item.value,
                              inputValue: item.value,
                              preSelect: _ctx.model.familyInfo['existInsurance' + (inx - 1)],
                              trackingLabel: _ctx.getExistingInsuranceLabel(inx - 1),
                              onRadioComponent: _ctx.handleRadioClick
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(item.displayValue), 1)
                              ]),
                              _: 2
                            }, 1032, ["name", "id", "inputValue", "preSelect", "trackingLabel", "onRadioComponent"])
                          ], 2))
                        }), 128)),
                        (!_ctx.model.pristineStep.get(_ctx.card.name) && !_ctx.model.familyInfo['existInsurance' + (inx - 1)])
                          ? (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_12))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.showPerson(inx - 1) && _ctx.model.familyInfo['existInsurance' + (inx - 1)] === 'ja')
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 'existInsuranceLabel' + (inx - 1),
                        class: "pb-3 text-left",
                        textContent: 'Hvilket forsikringsseleskab drejer det sig om'
                      }))
                    : _createCommentVNode("", true),
                  _withDirectives((_openBlock(), _createBlock(_component_SelectModalComponent, {
                    key: 'existingInsurance' + (inx - 1),
                    id: 'existingInsurance' + (inx - 1),
                    name: 'existingInsurance' + (inx - 1),
                    preSelect: _ctx.model.familyInfo['existingInsurance' + (inx - 1)],
                    innerData: _ctx.cms.insuranceCompanies,
                    selected: _ctx.model.familyInfo['existingInsurance' + (inx - 1)] !== undefined,
                    placeholder: "Vælg forsikringsselskab",
                    visibleError: !_ctx.model.pristineStep.get(_ctx.card.name),
                    errorMsgOverride: "Du skal vælge et forsikringsselskab",
                    "onSelectModalComponent:selected": _ctx.selectExistingInsuranceChild
                  }, null, 8, ["id", "name", "preSelect", "innerData", "selected", "visibleError", "onSelectModalComponent:selected"])), [
                    [_vShow, _ctx.showPerson(inx - 1) && _ctx.model.familyInfo['existInsurance' + (inx - 1)] === 'ja']
                  ])
                ]),
                _: 2
              }, 1024))
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _createVNode(_TransitionGroup, { name: "slide-simple" }, {
      default: _withCtx(() => [
        (_ctx.showPerson(_ctx.model.familyInfo.personCountId + 1))
          ? (_openBlock(), _createElementBlock("div", {
              class: "pb-3 pt-5 text-left",
              textContent: _toDisplayString(
					_ctx.isChildAccident
						? 'Hvornår skal forsikringen gælde fra?'
						: 'Hvornår skal Børnefamilieforsikringen gælde fra?'
				),
              key: "validNowLabel"
            }, null, 8, _hoisted_13))
          : _createCommentVNode("", true),
        (_ctx.showPerson(_ctx.model.familyInfo.personCountId + 1))
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.validNowArray, (item, inx) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: _normalizeClass([inx + 1 === _ctx.validNowArray.length ? 'pb-3' : 'pb-2']),
                  key: 'validNow' + inx
                }, [
                  _createVNode(_component_RadioComponent, {
                    name: "validNow",
                    id: 'validNow' + item.value,
                    inputValue: item.value,
                    preSelect: _ctx.model.additionalInfo.validNow,
                    trackingLabel: 
							_ctx.isChildAccident
								? 'Hvornår skal forsikringen gælde fra?'
								: 'Hvornår skal Børnefamilieforsikringen gælde fra?'
						,
                    onRadioComponent: _ctx.handleRadioClick
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.displayValue), 1)
                    ]),
                    _: 2
                  }, 1032, ["id", "inputValue", "preSelect", "trackingLabel", "onRadioComponent"])
                ], 2))
              }), 128)),
              (!_ctx.model.pristineStep.get(_ctx.card.name) && !_ctx.model.additionalInfo.validNow)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, _hoisted_17))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (_ctx.model.additionalInfo.validNow === 'nej' && _ctx.showPerson(_ctx.model.familyInfo.personCountId + 1))
          ? (_openBlock(), _createBlock(_component_DatePickerComponent, {
              key: "validFromDate",
              class: "text-left mb-3",
              label: "",
              innerId: "validFromDate",
              innerData: _ctx.model.additionalInfo,
              placeholder: "F.eks. 21-12-2020",
              validateOnLoad: !_ctx.model.pristineStep.get(_ctx.card.name),
              validationRule: "AfterToday",
              dateLimitIncluded: true
            }, null, 8, ["innerData", "validateOnLoad"]))
          : _createCommentVNode("", true),
        _withDirectives(_createVNode(_component_SegmentedControlComponent, {
          key: "skader",
          class: "pb-3",
          id: "skader",
          options: _ctx.skaderOptions,
          labels: _ctx.skaderLabels,
          preSelected: _ctx.model.additionalInfo.skader,
          controlsPerRow: 4,
          onSegmentedComponent: _ctx.handleRadioClick
        }, {
          default: _withCtx(() => [
            _hoisted_18
          ]),
          _: 1
        }, 8, ["options", "labels", "preSelected", "onSegmentedComponent"]), [
          [_vShow, !_ctx.model.multipleProducts && _ctx.isInsuranceInfoFilled]
        ]),
        (
					!_ctx.model.pristineStep.get(_ctx.card.name) &&
					!_ctx.model.multipleProducts &&
					_ctx.isInsuranceInfoFilled &&
					!_ctx.model.additionalInfo.skader
				)
          ? (_openBlock(), _createElementBlock("div", _hoisted_19, _hoisted_21))
          : _createCommentVNode("", true),
        _withDirectives(_createElementVNode("div", _hoisted_22, [
          _createElementVNode("span", null, _toDisplayString(_ctx.cms.rkiHeader), 1),
          (_ctx.cms.rkiPopover)
            ? (_openBlock(), _createBlock(_component_PopoverComponent, {
                key: 0,
                type: "icon",
                class: "page-component__popover text-left",
                buttonClass: "popover__icon popover__icon__questionmark",
                innerData: _ctx.cms.rkiPopover
              }, null, 8, ["innerData"]))
            : _createCommentVNode("", true)
        ], 512), [
          [_vShow, !_ctx.model.multipleProducts && _ctx.isInsuranceInfoFilled && _ctx.skaderOk]
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.jaNejArray, (item, inx) => {
          return _withDirectives((_openBlock(), _createElementBlock("div", {
            class: _normalizeClass([inx + 1 === _ctx.jaNejArray.length ? 'pb-3' : 'pb-2']),
            key: 'rki' + inx
          }, [
            _createVNode(_component_RadioComponent, {
              name: "rki",
              id: 'rki' + item.value,
              inputValue: item.value,
              preSelect: _ctx.model.additionalInfo.rki,
              trackingLabel: _ctx.cms.rkiHeader,
              onRadioComponent: _ctx.handleRadioClick
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(item.displayValue), 1)
              ]),
              _: 2
            }, 1032, ["id", "inputValue", "preSelect", "trackingLabel", "onRadioComponent"])
          ], 2)), [
            [_vShow, !_ctx.model.multipleProducts && _ctx.isInsuranceInfoFilled && _ctx.skaderOk]
          ])
        }), 128)),
        (!_ctx.model.pristineStep.get(_ctx.card.name) && _ctx.model.additionalInfo.rki === undefined)
          ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_23, _hoisted_25, 512)), [
              [_vShow, !_ctx.model.multipleProducts && _ctx.isInsuranceInfoFilled && _ctx.skaderOk]
            ])
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_ButtonTapComponent, {
      class: _normalizeClass([_ctx.card.buttonStyle, 'mt-3', { 'btn-disabled': !_ctx.isValid }]),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.nextStep())),
      "data-gtm": _ctx.cms.dataGtm,
      "data-gtm-click-text": _ctx.card.routePath
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.getNextCardLinkText()), 1)
      ]),
      _: 1
    }, 8, ["class", "data-gtm", "data-gtm-click-text"])
  ]))
}